import { z } from 'zod';

import { CssStyleSchema, SectionPropsSchema } from '@wp-block-builder/defaults';

export default function defineBlock<TType extends string, TProps extends z.ZodObject>(type: TType, props: TProps) {
  return z.object({
    id: z.string(),
    type: z.literal(type),
    style: CssStyleSchema.nullish(),
    sectionProps: SectionPropsSchema.nullish(),
    props: props.nullish(),
  });
}
